import requests from './httpService';

const NoteService = {
  getAllNotes(classId = null) {
    const queryParams = classId ? `?classId=${classId}` : '';
    return requests.get(`/note/list${queryParams}`);
  },

  getNotesGroupedByStudent() {
    return requests.get(`/note/grouped-by-student`);
  },

  // -------- Chat APIs --------
  getChatConversations() {
    return requests.get(`/note/chat/conversations`);
  },

  getChatMessages(studentId) {
    return requests.get(`/note/chat/${studentId}`);
  },

  getChatMessagesByNoteId(noteId) {
    return requests.get(`/note/chat/note/${noteId}`);
  },

  sendChatMessage(body) {
    return requests.post(`/note/chat/send`, body);
  },

  getUnreadSummary() {
    return requests.get(`/note/chat/unread-summary`);
  },

  markNoteRead(noteId) {
    return requests.post(`/note/chat/mark-read`, { noteId });
  },

  createNote(body) {
    return requests.post('/note/add', body); 
  },

  deleteNote(body) {
    return requests.delete(`/note/${body._id}`); 
  },

  updateNote(body) {
    return requests.put(`/note/${body._id}`, body); 
  },

  findNoteList(body) {
    return requests.post('/note/find', body);
  },

  getNoteById(id) {
    return requests.get(`/note/${id}`);
  },
};

export default NoteService;

